// Common OS delays to be consistent
export enum Delay {
  Search = 300,
  Tooltip = 500,
  ToastShort = 5000,
  ToastLong = 10000,
}
